import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { TemplateEnum } from 'src/app/core/enums/template.enum';
import { getThemeId } from '../../selectors/branding.selector';

@Component({
    selector: 'app-icon-calendar',
    templateUrl: './icon-calendar.component.html',
    styleUrls: ['./icon-calendar.component.scss']
})
export class IconCalendarComponent implements OnInit {

    @Input() cssClass = '';

    template$: Observable<TemplateEnum>;
    templateEnum = TemplateEnum;

    constructor(private store: Store<AppState>) { }

    ngOnInit() {
        this.template$ = this.store.select(getThemeId);
    }

}
